import React, { useEffect, useState } from 'react';
import {
  Modal,
  Form,
  message,
  Button,
  Card,
  Row,
  Col,
  Typography,
  Descriptions,
  Divider,
  List,
  Tag,
  Radio,
  Switch,
  Spin,
} from 'antd';
import moment from 'moment';
import _axios from '../../services/api';
import { API_ROUTES, ORDER_BASE_URL } from '../../utils/constants';
import { getAuthToken, getCurrentUser } from '../../utils/authHelpers';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './PricingComponent.scss';
import { setIsSignIn } from '../../features/Auth/authSlice';
import { setStoreCreatedOrderData, setUserType } from '../../features/Global/globalSlice';
import { convertCurrency } from '../../utils/price';
import { get_all_Subscriptions_org, get_latest_Subscriptions_org } from '../../features/Organization/OrganizationInfo/OrganizationSlice';
import ScreenFreezLoader from '../../components/CommonElements/ScreenFreezLoader';
import PaymentScreenFreezLoader from '../../components/CommonElements/PaymentScreenFreez';
import { setIsRedirectingToPaymentCheckoutPage, setOrderDetails } from '../../features/Organization/Jobs/jobSlice';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { get_all_Subscriptions_jobseeker, get_latest_Subscriptions_jobseeker } from '../../features/UserInfo/UserSlice';
import AppSecureStorage from '../../services/storage/secureStorage';

const { Title, Text } = Typography;
const storage = new AppSecureStorage()

const PricingComponent = ({ visible, onClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUser = getCurrentUser();
  const [loading, setLoading] = useState(true);
  const [billing, setBilling] = useState('monthly');
  const [currency, setCurrency] = useState('INR');
  const [form] = Form.useForm();
  const token = getAuthToken();
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [userTypes, setUserTypes] = useState('candidate');
  const [allPlans, setAllPlans] = useState([]);
  const [redirecting, setRedirecting] = useState(true);
  const [isRedirectingToPayment, setIsRedirectingToPayment] = useState(false);
  // const [showBoostPlans, setShowBoostPlans] = useState(false);


  const { isBoosting, storeJobIdForBoostJob, isTokenOpen, isPricingShow, isPaymentProcessingStart , orderDetails} =
    useSelector((state) => state.jobs)

  const { userProfile } = useSelector((s) => s.global);
  const { allSubscriptions, latestSubscriptions } = useSelector((s) => s.userData);
  const [showBoostPlans, setShowBoostPlans] = useState(isPaymentProcessingStart);


  useEffect(() => {
    if (!visible) return;
    const fetchPlans = async () => {
      setLoading(true);
      try {
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const res = await _axios.get(API_ROUTES.PRICES.GET_ALL_PRICES, { headers });
        if (res.data.success) setAllPlans(res.data.data || []);
        else message.error(res.data.message || 'Failed to load plans');
      } catch (err) {
        message.error('Error loading pricing plans');
      } finally {
        setLoading(false);
      }
    };
    fetchPlans();
  }, [visible]);

  console.log("orderDetails" , orderDetails)

  const handleSubmit = () => {
    if (token) {
      // if (currentUser === 'organization') {
      handleSubscribe()
      // } else {
      //   handleSubscribeJobseeker()
      // }
    } else {
      dispatch(setIsSignIn(true));
      dispatch(setUserType(userTypes === 'candidate' ? 'employee' : 'organization'));
      navigate('/login');
    }
  };

  const getFilteredPlansBoost = () => {
    return allPlans?.filter(p =>
      p?.userType === 'organization' && p?.planName?.toLowerCase()?.includes('boost')
    );
  };
  const getFilteredPlansAll = () => {
    if (token) {
      const type = currentUser;
      if (type === 'organization') return allPlans.filter(p => p.userType === 'organization');
      if (type === 'employee') return allPlans.filter(p => p.userType === 'jobSeeker');
      return [];
    } else {
      return userTypes === 'candidate'
        ? allPlans.filter(p => p.userType === 'jobSeeker')
        : allPlans.filter(p => p.userType === 'organization');
    }
  };

  const getFilteredPlans = () => {
    if (isPaymentProcessingStart) {
      return getFilteredPlansBoost()
    } else {
      return getFilteredPlansAll()
    }
  };


  // const selectedPlanList = getFilteredPlans();

  // const selectedPlanList = [...getFilteredPlans()]?.sort((a, b) => {
  //   const order = ['basic', 'standard', 'premium'];
  //   return (
  //     order?.indexOf(a.planName?.toLowerCase()) -
  //     order?.indexOf(b.planName?.toLowerCase())
  //   );
  // });

  const allFilteredPlans = getFilteredPlans();

  const nonBoostPlans = [...allFilteredPlans]
    .filter(plan => !plan.planName?.toLowerCase()?.includes('boost'))
    .sort((a, b) => {
      const order = ['basic', 'standard', 'premium'];
      return order.indexOf(a.planName?.toLowerCase()) - order.indexOf(b.planName?.toLowerCase());
    });

  const boostPlans = [...allFilteredPlans]
    .filter(plan => plan.planName?.toLowerCase()?.includes('boost'))
    .sort((a, b) => {
      const order = ['basic boost', 'standard boost', 'premium boost'];
      return order.indexOf(a.planName?.toLowerCase()) - order.indexOf(b.planName?.toLowerCase());
    });


  const selectedPlanList = isPaymentProcessingStart
    ? boostPlans
    : [...nonBoostPlans, ...(showBoostPlans ? boostPlans : [])];


  const currencySymbol = currency === 'USD' ? '$' : '₹';

  const handleApplySubscription = async (values) => {
    const API_URL = currentUser === "organization" ? API_ROUTES.ORGANIZATION.SUBSCRIPTION : API_ROUTES.JOBSEEKER.GET_ALL_SUBSCRIPTIONS
    setLoading(true);
    try {
      const response = await _axios.post(
        API_URL,
        { referalCode: values },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      );

      message.success(response.data.message);
      // setIsSubscription(false);
      if (currentUser === "organization") {
        dispatch(get_latest_Subscriptions_org(navigate));
        dispatch(get_all_Subscriptions_org(navigate));
      } else {
        dispatch(get_all_Subscriptions_jobseeker(navigate));
        dispatch(get_latest_Subscriptions_jobseeker(navigate));
      }
      // setSubscription(response.data.subscription);
      form.resetFields();
    } catch (err) {
      console.error(err);
      message.error(err.response?.data?.error || 'Subscription failed');
    } finally {
      setLoading(false);
    }
  };

  const handleSubscribe = async () => {

    if (!selectedPlan) {
      message.error("Please select a plan before proceeding.");
      return;
    }

    const rawAmount = selectedPlan?.price;

    if (!rawAmount || isNaN(rawAmount)) {
      message.error("Invalid price value in selected plan.");
      return;
    }

    const amt = Number(rawAmount);
    // setIsRedirectingToPayment(true);
    dispatch(setIsRedirectingToPaymentCheckoutPage(true));

    try {
      const res = await _axios.post(
        `${ORDER_BASE_URL}orders/create`,
        {
          order_amount: amt,
          order_currency: currency,
          customer_details: {
            customer_id: userProfile._id,
            customer_name: userProfile.name,
            customer_email: currentUser === "organization" ? userProfile.companyEmail : userProfile?.email,
            customer_phone: currentUser === "organization" ? userProfile?.contact : userProfile?.mobile,
          },
          order_note: `Subscription for ${selectedPlan.planName || selectedPlan.name}`,
          order_meta: {
            return_url: `${window.location.origin}/payment-status`,
            payment_methods: 'cc,dc,upi,nb,app,paylater',
          },
        },
        
      );

      const sessionId = res?.data?.data?.payment_session_id;
      storage.setItem('order_details', res.data)
      dispatch(setOrderDetails(res.data))
      if (sessionId) {
        dispatch(setStoreCreatedOrderData(sessionId));
        navigate(`/checkout/${sessionId}`);
      } else {
        throw new Error('Missing payment session ID');
      }
    } catch (err) {
      console.error(err);
      message.error('Subscription failed. Please try again.');
      setLoading(false); // Only on error
      setIsRedirectingToPayment(false);
    }
  };

  const handleClose = () => {
    onClose();
    setShowBoostPlans(false)
  }

  return (
    <Modal
      centered
      open={visible}
      onCancel={handleClose}
      footer={null}
      width={1000}
      className="jobseekerSubscription"
    >
      <Title level={3} className="text-center text-white large-title">
        Choose Your Subscription Plan
      </Title>

      {!token && <div className="usertype-switch">
        <Switch
          size="default"
          checked={userTypes === 'recruiter'}
          onChange={(checked) => {
            setUserTypes(checked ? 'recruiter' : 'candidate');
            setSelectedPlan(null);
            setShowBoostPlans(false)
          }}
          checkedChildren="Recruiter"
          unCheckedChildren="Candidate"
          className="custom-toggle-switch btnfonts"
        />
      </div>}

      <Row justify="center" gutter={[16, 16]} style={{ marginBottom: 24 }} align={'middle'}>
        <Col>
          <Radio.Group
            value={currency}
            onChange={(e) => setCurrency(e.target.value)}
            optionType="button"
            buttonStyle="solid"
            size="middle"
          >
            <Radio.Button className={currency === 'INR' ? 'blueGradiant border-none' : 'border-none'} value="INR">₹ INR</Radio.Button>
            <Radio.Button className={currency === 'USD' ? 'blueGradiant border-none' : 'border-none'} value="USD">$ USD</Radio.Button>
          </Radio.Group>
        </Col>

        <Col>
          <Radio.Group
            value={billing}
            onChange={(e) => setBilling(e.target.value)}
            optionType="button"
            buttonStyle="solid"
            size="middle"
          >
            <Radio.Button className={billing === 'monthly' ? 'blueGradiant border-none' : 'border-none'} value="monthly">Monthly</Radio.Button>
            <Radio.Button className={billing === 'annually' ? 'blueGradiant border-none' : 'border-none'} value="annually">Annually</Radio.Button>
          </Radio.Group>
        </Col>
      </Row>

      {isRedirectingToPayment && (
        <div className="payment-processing-overlay">
          <div className="processing-box">
            <Spin size="large" />
            <p style={{ marginTop: '1rem', color: '#fff', fontWeight: 500 }}>
              Please wait, redirecting to payment...
            </p>
          </div>
        </div>
      )}


      {/* <Row gutter={[24, 24]} justify="center" className="plans-row">
        {selectedPlanList.map((plan) => {
          const planPrice = plan.price;
          const original = plan.originalPrice || 0;
          const fromCurrency = 'INR';
          const convertedPrice = convertCurrency(plan.price, fromCurrency, currency);
          const convertedOriginal = convertCurrency(plan.originalPrice || 0, fromCurrency, currency);

          return (
            <Col xs={24} sm={12} md={8} lg={6} xl={8} key={plan._id}>
              <Card
                hoverable
                onClick={() => setSelectedPlan(plan)}
                className={`plan-card-price ${selectedPlan?._id === plan._id ? 'active-plan-card-price' : ''}`}
              >
                <Tag className="text-black roundTags">{plan.planName}</Tag>

                <div className="text-center text-white" style={{ marginTop: 12 }}>
                  <h2 className='text-white' style={{ fontSize: 26, marginBottom: 4 }}>{currencySymbol}{convertedPrice}</h2>
                  {convertedOriginal > convertedPrice && (
                    <div style={{ textDecoration: 'line-through', fontSize: 14, color: '#ccc' }}>
                      {currencySymbol}{convertedOriginal}
                    </div>
                  )}
                </div>

                <Divider style={{ borderColor: 'rgba(255, 255, 255, 0.15)' }} />

                <ul className="plan-features text-white" style={{ listStyle: 'none', padding: 0, margin: 0, textAlign: 'left' }}>
                  {plan.feature?.map((feature, i) => (
                    <li key={i} style={{ marginBottom: 8 }}>
                      ✅ {feature}
                    </li>
                  ))}
                </ul>
              </Card>
            </Col>
          );
        })}
      </Row> */}

      {/* <Row gutter={[24, 24]} justify="center" className="plans-row">
        {[...nonBoostPlans, ...(showBoostPlans ? boostPlans : [])].map((plan) => {
          const planPrice = plan.price;
          const original = plan.originalPrice || 0;
          const convertedPrice = convertCurrency(plan.price, 'INR', currency);
          const convertedOriginal = convertCurrency(plan.originalPrice || 0, 'INR', currency);

          return (
            <Col xs={24} sm={12} md={8} lg={6} xl={8} key={plan._id}>
              <Card
                hoverable
                onClick={() => setSelectedPlan(plan)}
                className={`plan-card-price ${selectedPlan?._id === plan._id ? 'active-plan-card-price' : ''}`}
              >
                <Tag className="text-black roundTags">{plan.planName}</Tag>
                <div className="text-center text-white" style={{ marginTop: 12 }}>
                  <h2 className='text-white' style={{ fontSize: 26, marginBottom: 4 }}>{currencySymbol}{convertedPrice}</h2>
                  {convertedOriginal > convertedPrice && (
                    <div style={{ textDecoration: 'line-through', fontSize: 14, color: '#ccc' }}>
                      {currencySymbol}{convertedOriginal}
                    </div>
                  )}
                </div>
                <Divider style={{ borderColor: 'rgba(255, 255, 255, 0.15)' }} />
                <ul className="plan-features text-white" style={{ listStyle: 'none', padding: 0, margin: 0, textAlign: 'left' }}>
                  {plan.feature?.map((feature, i) => (
                    <li key={i} style={{ marginBottom: 8 }}>
                      ✅ {feature}
                    </li>
                  ))}
                </ul>
              </Card>
            </Col>
          );
        })}
      </Row> */}
      <Row gutter={[24, 24]} justify="center" className="plans-row">
        {selectedPlanList.map((plan) => {
          const planPrice = plan.price;
          const original = plan.originalPrice || 0;
          const convertedPrice = convertCurrency(plan.price, 'INR', currency);
          const convertedOriginal = convertCurrency(plan.originalPrice || 0, 'INR', currency);

          return (
            <Col xs={24} sm={12} md={8} lg={6} xl={8} key={plan._id}>
              <Card
                hoverable
                onClick={() => setSelectedPlan(plan)}
                // className={`plan-card-price ${selectedPlan?._id === plan._id ? 'active-plan-card-price' : ''}`}
                className={`plan-card-price ${selectedPlan?._id === plan._id ? 'active-plan-card-price' : ''} 
                ${plan.planName == 'Standard' ? 'plan-card-price-higlighted' : ''}`}
              >
                <Tag className="text-black roundTags">{plan.planName}</Tag>

                <div className="text-center text-white" style={{ marginTop: 12 }}>
                  <h2 className='text-white' style={{ fontSize: 26, marginBottom: 4 }}>{currencySymbol}{convertedPrice}</h2>
                  {convertedOriginal > convertedPrice && (
                    <div style={{ textDecoration: 'line-through', fontSize: 14, color: '#ccc' }}>
                      {currencySymbol}{convertedOriginal}
                    </div>
                  )}
                </div>

                <Divider style={{ borderColor: 'rgba(255, 255, 255, 0.15)' }} />

                <ul className="plan-features text-white" style={{ listStyle: 'none', padding: 0, margin: 0, textAlign: 'left' }}>
                  {plan.feature?.map((feature, i) => (
                    <li key={i} style={{ marginBottom: 8 }}>
                      ✅ {feature}
                    </li>
                  ))}
                </ul>
              </Card>
            </Col>
          );
        })}
      </Row>


      {
        token && <Row className='mb20' justify="center" gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} lg={8}>
            <Button className='fullwidth' shape='round' onClick={() => handleApplySubscription('PREMIUM100')}>
              🧪 Test: Apply Prime Subscription
            </Button>
          </Col>
          <Col xs={24} sm={12} md={8} lg={8}>
            <Button className='fullwidth' shape='round' onClick={() => handleApplySubscription('STANDARD100')}>
              🧪 Test: Apply Standard Subscription
            </Button>
          </Col>
          <Col xs={24} sm={12} md={8} lg={8}>
            <Button className='fullwidth' shape='round' onClick={() => handleApplySubscription('free')}>
              🧪 Test: Apply Basic Subscription
            </Button>
          </Col>
        </Row>
      }

      {/* {!isPaymentProcessingStart && boostPlans.length > 0 && !showBoostPlans && (
        <Row justify="center" className="mt-2 mb-3">
          <Button
            type="default"
            shape="round"
            size="large"
            onClick={() => setShowBoostPlans(true)}
            className="blueGradiant text-white btnfonts"
            style={{ border: 'none', fontWeight: 500 }}
          >
            🚀 Explore Boost Plans
          </Button>
        </Row>
      )} */}

      {boostPlans.length > 0 && !isPaymentProcessingStart && (
        <Row justify="center" className="mt-2 mb-3">
          <Button
            type="default"
            shape="round"
            size="large"
            onClick={() => setShowBoostPlans(prev => !prev)}
            className="blueGradiant text-white btnfonts"
            style={{ border: 'none', fontWeight: 500 }}
          >
            {/* {showBoostPlans ? '👁️ Hide Boost Plans' : '🚀 Explore Boost Plans'} */}
            {showBoostPlans ? <div><EyeInvisibleOutlined /> <span>Hide Boost Plans</span></div> : <div><EyeOutlined />  <span>Explore Boost Plans</span></div>}
          </Button>
        </Row>
      )}



      <Row justify="end" gutter={[16, 16]}>
        <Col xs={24} sm={12} md={6}>
          <Button
            type="primary"
            htmlType="button"
            shape="round"
            className="bg-white fullwidth btnfonts text-black"
            loading={loading}
            onClick={handleSubmit}
          >
            Order Now
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default PricingComponent;